// Staff invites on the platform routes (registration plan S1/S2;
// backend/src/routes/admin/platform-invites.ts, API_CONTRACT.md › Invites).
//
//   GET  /platform/leagues/:id/invites          → { invites }   a league's pending invites
//   POST /platform/leagues/:id/invites          { email, role } → 201 { invite, delivery, link }
//   GET  /platform/super-admin-invites          → { invites }
//   POST /platform/super-admin-invites          { email } → 201 { invite, delivery, link }
//   POST /platform/invites/:inviteId/resend     → { invite, delivery, link }   (same link)
//   POST /platform/invites/:inviteId/revoke     → { invite }
//   GET  /platform/invites/:inviteId/link       → { url, expires_at }
//
// Links come only from the server (never built here). 409s: invite_pending
// (details.invite_id), already_member, already_super_admin, account_inactive,
// invite_expired, resend_limit, invite_not_pending, no_platform_address.

import { apiFetch } from './client'
import type { InviteLink, InviteSendResult, LeagueRole, StaffInvite } from './types'

export function listTenantInvites(id: number, signal?: AbortSignal): Promise<StaffInvite[]> {
  return apiFetch<{ invites: StaffInvite[] }>(`/admin/platform/leagues/${id}/invites`, { signal }).then((r) => r.invites)
}

export function inviteToTenant(id: number, body: { email: string; role: LeagueRole }): Promise<InviteSendResult> {
  return apiFetch(`/admin/platform/leagues/${id}/invites`, { method: 'POST', body })
}

export function listSuperAdminInvites(signal?: AbortSignal): Promise<StaffInvite[]> {
  return apiFetch<{ invites: StaffInvite[] }>('/admin/platform/super-admin-invites', { signal }).then((r) => r.invites)
}

export function inviteSuperAdmin(email: string): Promise<InviteSendResult> {
  return apiFetch('/admin/platform/super-admin-invites', { method: 'POST', body: { email } })
}

export function resendInvite(inviteId: number): Promise<InviteSendResult> {
  return apiFetch(`/admin/platform/invites/${inviteId}/resend`, { method: 'POST' })
}

export function revokeInvite(inviteId: number): Promise<{ invite: StaffInvite }> {
  return apiFetch(`/admin/platform/invites/${inviteId}/revoke`, { method: 'POST' })
}

export function inviteLink(inviteId: number): Promise<InviteLink> {
  return apiFetch(`/admin/platform/invites/${inviteId}/link`)
}
